import ExcelJS from "exceljs";

export async function createExcelFile(indicators) {
    const workbook = new ExcelJS.Workbook();

    // eslint-disable-next-line array-callback-return
    indicators.map(indicator => {
        const worksheet = workbook.addWorksheet(indicator.codigo + '-' + indicator.language+'-'+indicator.year_reference);
        createFile(indicator, worksheet)
    })

    // Salve o arquivo Excel
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);


    // Crie um link para download
    const a = document.createElement('a');
    a.href = url;
    a.download = 'indicators_list.xlsx'
    a.click();

    URL.revokeObjectURL(url);
}

export async function createIndividualExcelFile(indicator) {

    const workbook = new ExcelJS.Workbook();

        const worksheet = workbook.addWorksheet(indicator.codigo);
        createFile(indicator, worksheet)

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);

        // Crie um link para download
        const a = document.createElement('a');
        a.href = url;
        a.download = indicator.codigo+'-'+indicator.language+'-'+indicator.year_reference
            +'.xlsx';

        a.click();
        URL.revokeObjectURL(url);
}

const createFile = (indicator, worksheet) => {

    console.log('indicator', indicator.tables)

    // Adicione dados à planilha
    worksheet.addRow(['start']);
    worksheet.addRow(['language', '', indicator.language]);
    worksheet.addRow(['#', '', 'Ano de publicação']);
    worksheet.addRow(['year_reference', 'string', indicator.year_reference]);
    worksheet.addRow(['code', '', indicator.codigo]);

    worksheet.addRow([]);
    worksheet.addRow(['#', '', 'Titulo do indicador']);
    worksheet.addRow(['title', 'string', indicator.titulo]);

    worksheet.addRow([]);
    worksheet.addRow(['#', '', 'LINK DO(S) INDICADOR(ES) REPORTADO(S) NO CICLO ANTERIOR E PARA APOIAR A ÁREA NAS RESPOSTAS DO CICLO ATUAL']);
    worksheet.addRow(['links', 'string', indicator.links]);

    worksheet.addRow([]);
    worksheet.addRow(['#', '', 'Contexto: (explicações necessárias para a compreensão do indicador)']);
    worksheet.addRow(['context', 'string', indicator.contexto]);

    worksheet.addRow([]);
    worksheet.addRow(['#', '', 'Racional utilizado/ Local de retirada de informações reportadas:']);
    worksheet.addRow(['rational', 'string', indicator.racional]);

    worksheet.addRow([]);
    worksheet.addRow(['#', '', 'Informações complementares:']);
    worksheet.addRow(['additional_information', 'string', indicator.informacoes_complementares]);

    worksheet.addRow([]);
    worksheet.addRow(['#', '', 'Dados (tabela e insumos para gráficos):']);
    indicator?.tables?.forEach((table) => {

        worksheet.addRow(['', '', '']);
        worksheet.addRow(['table_title', '', table.titulo]);
        worksheet.addRow(['', '', '']);

        table?.headers?.forEach((row, indexHeader) => {
            if (indexHeader === 0) {
                worksheet.addRow(['start_data_table', '']);
                const headerData = row.map((cell) => cell.value);
                worksheet.addRow(['table_header','', ...headerData]);
            }

            if (indexHeader === 1) {
                const subHeaderData = row.map((cell) => cell.value);
                worksheet.addRow(['table_subheader','', ...subHeaderData]);
            }

        });

        table?.rows?.forEach((row, index) => {
            if(index === 0) {
                const rowData = row.map((cell) => cell.unit);
                worksheet.addRow(['unit','', ...rowData]);
            }
        });
        table?.rows?.forEach((row, index) => {
            if(index === 0) {
                const rowData = row.map((cell) => cell.unit_convert);
                worksheet.addRow(['unit_convert','', ...rowData]);
            }
        });

        table?.rows?.forEach((row) => {
            const rowData = row.map((cell) => cell.value);
            worksheet.addRow(['table_row','', ...rowData]);
        });

        //if (index !== 0) {
        worksheet.addRow(['end_data_table', '']);

        worksheet.addRow([]);
        worksheet.addRow(['#', '', 'Notas de rodapé:']);
        worksheet.addRow(['table_footer', 'string', table.footer]);

        worksheet.addRow([]);
        //  }
    });

    worksheet.addRow(['the_end', '']);


    worksheet.mergeCells('C3:O3');
    const mergedCellYear = worksheet.getCell('C3:O3');
    mergedCellYear.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '404040' },
    };
    mergedCellYear.font = {size: 10, bold: true, color: { argb: 'FFFFFF' } }

    worksheet.mergeCells('C7:O7');
    const mergedCellTitle = worksheet.getCell('C7:O7');
    mergedCellTitle.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '404040' }, // Cor de fundo vermelha
    };
    mergedCellTitle.font = {size: 10, bold: true, color: { argb: 'FFFFFF' } }

    worksheet.mergeCells('C10:O10');
    const mergedCellLinks = worksheet.getCell('C10:O10');
    mergedCellLinks.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '404040' },
    };
    mergedCellLinks.font = {size: 10, bold: true, color: { argb: 'FFFFFF' } }

    worksheet.mergeCells('C13:O13');
    const mergedCellContext = worksheet.getCell('C13:O13');
    mergedCellContext.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '404040' },
    };
    mergedCellContext.font = {size: 10, bold: true, color: { argb: 'FFFFFF' } }

    worksheet.mergeCells('C16:O16');
    const mergedCellRational = worksheet.getCell('C16:O16');
    mergedCellRational.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '404040' },
    };
    mergedCellRational.font = {size: 10, bold: true, color: { argb: 'FFFFFF' } }

    worksheet.mergeCells('C19:O19');
    const mergedCellComplements = worksheet.getCell('C19:O19');
    mergedCellComplements.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '404040' },
    };
    mergedCellComplements.font = {size: 10, bold: true, color: { argb: 'FFFFFF' } }

    worksheet.mergeCells('C22:O22');
    const mergedCellTable = worksheet.getCell('C22:O22');
    mergedCellTable.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '404040' },
    };
    mergedCellTable.font = {size: 10, bold: true, color: { argb: 'FFFFFF' } }

    const columnA = worksheet.getColumn('A');
    columnA.eachCell({ includeEmpty: true }, (cell) => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFCC' },
        };
        cell.font = { size: 9 };
        cell.alignment = {  horizontal: 'center' };
        cell.border = {
            top: { style: 'thin', color: { argb: 'D9D9D9' } },
            left: { style: 'thin', color: { argb: 'D9D9D9' } },
            bottom: { style: 'thin', color: { argb: 'D9D9D9' } },
            right: { style: 'thin', color: { argb: 'D9D9D9' } },
        };
    });

    const columnB = worksheet.getColumn('B');
    columnB.eachCell({ includeEmpty: true }, (cell) => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFCC' },
        };
        cell.font = { size: 9 };
        cell.alignment = {  horizontal: 'center' };
        cell.border = {
            top: { style: 'thin', color: { argb: 'D9D9D9' } },
            left: { style: 'thin', color: { argb: 'D9D9D9' } },
            bottom: { style: 'thin', color: { argb: 'D9D9D9' } },
            right: { style: 'thin', color: { argb: 'D9D9D9' } },
        };
    });

    return worksheet

}